module.exports = __webpack_public_path__ + "static/media/success.18bc4a40.mp3";